import { createAction } from 'redux-actions';

import { CREATE_SHIPMENT_ORDER } from './constants';

export const successCreateShipmentOrder = createAction(CREATE_SHIPMENT_ORDER.SUCCESS);
